<template>
  <div
    class="spotlight-card"
    :style="{ backgroundImage: `url(${require(`@/assets/dhs/${spotlight.category}-card.png`)})` }"
  >
    <router-link
      class="text-white card-link"
      @click.native="trackClick($event, spotlight)"
      :to="`${getProductBasePath('spotlight')}/categories/${spotlight.category}`"
    >
      <div class="spotlight-dhs-container d-flex">
        <h4 class="text-white my-0 dhs-text">
          {{ $t(`message.spotlightV2.spotlightCategories.${spotlight.category}`) }}
        </h4>
      </div>
    </router-link>
  </div>
</template>

<script>
import log from '@/services/log';

export default {
  name: 'SpotlightDHSCard',
  props: {
    spotlight: {
      type: Object,
      required: true,
    },
  },
  methods: {
    trackClick(e, spotlight) {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `dhs.category.${spotlight.category}`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.spotlight-card {
  border-radius: 6px;
  height: 125px;
  padding: 16px;
  top: 0;
  right: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center right;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    margin-bottom: 0.5rem;
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }

  @media (min-width: 575px) {
    height: 141px;
  }
}

.spotlight-dhs-container {
  z-index: 10;
  position: relative;
  height: 100%;
  align-items: flex-end;
}
</style>
